import { createContext, useContext, useState } from 'react';

// Criando um contexto para compartilhar o estado entre componentes
const CommunicationContext = createContext();

// Provider component que será usado no nível mais alto
export const CommunicationProvider = ({ children }) => {
  const [activeComponent, setActiveComponent] = useState(null);

  // Funções para alterar o estado dos modais
  const showAddNote = () => setActiveComponent('add');
  const showReplyNote = () => setActiveComponent('reply');
  const showForwardNote = () => setActiveComponent('forward');
  const closeComponent = () => setActiveComponent(null);

  const value = {
    activeComponent,
    setActiveComponent,
    showAddNote,
    showReplyNote,
    showForwardNote,
    closeComponent
  };

  return (
    <CommunicationContext.Provider value={value}>
      {children}
    </CommunicationContext.Provider>
  );
};

// Hook personalizado para acessar o contexto
const useCommunication = () => {
  const context = useContext(CommunicationContext);
  if (!context) {
    throw new Error('useCommunication must be used within a CommunicationProvider');
  }
  return context;
};

export default useCommunication;